import Papa from 'papaparse';

type CsvCell = string | number | null | undefined;

type DownloadCsvRows = (params: {
  rows: CsvCell[][];
  filename: string;
  delimiter?: string;
}) => void;

export const sanitizeFilename = (value?: string | null, fallback = 'export') => {
  const normalized = String(value || '')
    .trim()
    .replace(/[^a-z0-9]+/gi, '_')
    .replace(/^_+|_+$/g, '');

  return normalized || fallback;
};

export const downloadCsvRows: DownloadCsvRows = ({ rows, filename, delimiter = ',' }) => {
  const csvString = Papa.unparse(rows, { delimiter });
  const anchor = document.createElement('a');
  anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(csvString);
  anchor.target = '_blank';
  anchor.download = filename;
  anchor.click();
};
